export default {
  inserted(element: HTMLElement, { value }: any, vm: any) {
    element.addEventListener('click', () => {
      vm.context.$gtm.trackEvent(value);
    });
  },
};
